import { __awaiter, __decorate } from "tslib";
import { _SharePointQueryableInstance, _SharePointQueryableCollection, spInvokableFactory, } from "../sharepointqueryable.js";
import { defaultPath } from "../decorators.js";
import { Site } from "../sites/types.js";
import { tag } from "../telemetry.js";
let _HubSites = class _HubSites extends _SharePointQueryableCollection {
    /**
     * Gets a Hub Site from the collection by id
     *
     * @param id The Id of the Hub Site
     */
    getById(id) {
        return tag.configure(HubSite(this, `GetById?hubSiteId='${id}'`), "hss.getById");
    }
};
_HubSites = __decorate([
    defaultPath("_api/hubsites")
], _HubSites);
export { _HubSites };
export const HubSites = spInvokableFactory(_HubSites);
export class _HubSite extends _SharePointQueryableInstance {
    /**
     * Gets the ISite instance associated with this hubsite
     */
    getSite() {
        return __awaiter(this, void 0, void 0, function* () {
            const d = yield this.select("SiteUrl")();
            return Site(d.SiteUrl);
        });
    }
}
__decorate([
    tag("hs.getSite")
], _HubSite.prototype, "getSite", null);
export const HubSite = spInvokableFactory(_HubSite);
//# sourceMappingURL=types.js.map